"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JoinStatement = void 0;
const order_by_statement_controller_1 = require("../../orderby/order-by-statement-controller");
class JoinStatement {
    constructor(relation) {
        this.relation = relation;
        this.orderByStatementController = new order_by_statement_controller_1.OrderByStatementController(relation.getRelationObject().getPrimaryKey());
    }
    attach(object) {
        Object.defineProperty(object, this.relation.getObjectName(), {
            value: this.relation.findByObject(object, true),
            enumerable: true
        });
    }
    has(key) {
        return (key === this.relation.getPrettyName());
    }
    getRelation() {
        return this.relation;
    }
    hasStatements() { return false; }
    getStatements() { return []; }
    hasWhereStatements() { return false; }
    getWhereStatementController() { return null; }
    hasOrderByStatements() { return false; }
    getOrderByStatementController() {
        return this.orderByStatementController;
    }
    getJoinStatementController() { return null; }
}
exports.JoinStatement = JoinStatement;
